import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";

const GENERIC = "Hola, tengo una duda sobre las actividades";

let _activity = null;
const _subs = new Set();
export function setWhatsAppActivity(title) {
  _activity = title;
  _subs.forEach((f) => f(title));
}

const WaIcon = ({ size = 24 }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} className="fill-current" aria-hidden="true">
    <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.256.594 4.46 1.72 6.4L3.2 28.8l6.56-1.708a12.74 12.74 0 0 0 6.244 1.612h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.332-6.636-3.752-9.056A12.72 12.72 0 0 0 16.004 3.2zm0 23.2h-.004a10.6 10.6 0 0 1-5.4-1.48l-.388-.23-4.03 1.05 1.076-3.928-.252-.404a10.56 10.56 0 0 1-1.62-5.616c0-5.86 4.77-10.63 10.64-10.63 2.84 0 5.51 1.108 7.52 3.118a10.56 10.56 0 0 1 3.114 7.52c0 5.862-4.77 10.63-10.63 10.63zm5.83-7.96c-.32-.16-1.89-.932-2.182-1.038-.292-.106-.504-.16-.716.16-.212.32-.822 1.038-1.008 1.25-.186.212-.372.24-.692.08-.32-.16-1.35-.498-2.57-1.586-.95-.848-1.592-1.894-1.778-2.214-.186-.32-.02-.492.14-.652.144-.144.32-.372.48-.558.16-.186.212-.32.32-.532.106-.212.054-.398-.026-.558-.08-.16-.716-1.726-.98-2.364-.258-.62-.52-.536-.716-.546l-.61-.01c-.212 0-.558.08-.85.398-.292.32-1.114 1.09-1.114 2.656 0 1.566 1.14 3.08 1.3 3.292.16.212 2.244 3.426 5.436 4.804.76.328 1.352.524 1.814.67.762.242 1.456.208 2.004.126.612-.092 1.89-.772 2.156-1.518.266-.746.266-1.386.186-1.518-.08-.132-.292-.212-.612-.372z" />
  </svg>
);

export const WhatsAppButton = () => {
  const { pathname } = useLocation();
  const { branding } = useApp();
  const waNumber = (branding?.whatsapp_number || "34667396767").replace(/\D/g, "");
  const link = (text) => `https://wa.me/${waNumber}?text=${encodeURIComponent(text)}`;
  const [activity, setActivity] = useState(_activity);
  const [openMenu, setOpenMenu] = useState(false);

  useEffect(() => {
    const f = (t) => setActivity(t);
    _subs.add(f);
    return () => { _subs.delete(f); };
  }, []);
  useEffect(() => { setOpenMenu(false); }, [pathname]);

  if (pathname.startsWith("/admin")) return null;

  const btnCls = "flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/40 pl-4 pr-5 py-3.5 hover:bg-[#1FB855] hover:scale-105 active:scale-95 transition-transform duration-200";

  if (!activity) {
    return (
      <a data-testid="whatsapp-float-btn" href={link(GENERIC)} target="_blank" rel="noopener noreferrer" aria-label="Escríbenos por WhatsApp" className={`group fixed bottom-5 right-5 z-50 ${btnCls}`}>
        <WaIcon />
        <span className="text-sm font-bold whitespace-nowrap">WhatsApp</span>
      </a>
    );
  }

  const optCls = "flex items-center gap-2 rounded-2xl bg-white text-slate-700 shadow-lg border border-slate-100 px-4 py-2.5 text-sm font-bold hover:bg-slate-50 transition-colors";

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-2">
      {openMenu && (
        <div data-testid="whatsapp-menu" className="flex flex-col items-end gap-2 mb-1 animate-in slide-in-from-bottom-2 fade-in duration-200">
          <a data-testid="whatsapp-opt-activity" href={link(`Hola, tengo una duda sobre la actividad "${activity}"`)} target="_blank" rel="noopener noreferrer" className={optCls}>
            <span className="w-2 h-2 rounded-full bg-[#25D366]" /> Sobre: {activity.length > 28 ? activity.slice(0, 28) + "…" : activity}
          </a>
          <a data-testid="whatsapp-opt-other" href={link(GENERIC)} target="_blank" rel="noopener noreferrer" className={optCls}>
            <span className="w-2 h-2 rounded-full bg-slate-300" /> Otra pregunta
          </a>
        </div>
      )}
      <button data-testid="whatsapp-float-btn" onClick={() => setOpenMenu((o) => !o)} aria-label="Escríbenos por WhatsApp" className={`group ${btnCls}`}>
        <WaIcon />
        <span className="text-sm font-bold whitespace-nowrap">WhatsApp</span>
      </button>
    </div>
  );
};
